<div class="facial-recognition-image-uploader">
  <fgb-facial-recognition-uploader-header
    facialRecognitionHeading="{{ 'facial.recognition.validating.photo.heading' | translate }}"
    facialRecognitionSubheading="{{ 'facial.recognition.validating.photo.subheading' | translate }}"
    [stepCounter]="stepCounter"
    [showCloseButton]="true"
    (previousStepChange)="previousStepChange.emit()"
  ></fgb-facial-recognition-uploader-header>

  <div class="container facial-recognition-details-div mt-5 pt-5 text-center">
    <div class="spinner-border conicalProgressBar" role="status">
      <div class="overlay"></div>
      <span class="visually-hidden">
        {{ 'facial.recognition.validating.photo.loading' | translate }}
      </span>
    </div>
    <div class="font-size-14 validating-photo-details-heading mt-4">
      {{ 'facial.recognition.validating.photo.details.heading' | translate }}
    </div>
    <div class="font-size-14 validating-photo-details-subheading">
      {{ 'facial.recognition.validating.photo.details' | translate }}
    </div>
  </div>
</div>
